/* 🤖 this file was generated by svg-to-ts */
export const iconOpmainnet: {
  name: 'opmainnet';
  data: string;
} = {
  name: 'opmainnet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#opmainnet__clip0_2244_1943)"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m0 24.14v6.68c-6.34 0-11.49-5.14-11.49-11.49S9.65 7.84 16 7.84V1.16c6.34 0 11.49 5.14 11.49 11.49S22.35 24.14 16 24.14m5.51-8.19v.1q-3.645 1.815-5.46 5.46h-.1q-1.815-3.645-5.46-5.46v-.1q3.645-1.815 5.46-5.46h.1q1.815 3.645 5.46 5.46"/></g><defs><clipPath id="opmainnet__clip0_2244_1943"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
